import {Component, OnInit, ViewChild} from '@angular/core';
import {ValidationErrorService} from "../../../services/common/ValidationErrorService";
import {Localization} from "../../../data/Localization";
import {BehaviorSubject} from "rxjs";
import {IModal} from "../IModal";
import {BsModalRef} from "ngx-bootstrap/modal";
import {LocalizationService} from "../../../services/LocalizationService";
import {ConversionService} from "../../../services/ConversionService";
import {NotificationService, ToastType} from "../../../services/common/NotificationService";
import {ResourceSubmission} from "../../../domain/resources/ResourceSubmission";
import {ValidationException} from "../../../services/exceptions/ValidationException";
import {SelectableFrameworkRef} from "../../../domain/frameworks/SelectableFrameworkRef";
import {FrameworkSelectComponent} from "../../resources/create/single/edit-resource-submission/subcomponents/framework-select/framework-select.component";
import {FilterComponent} from "../../common/filter/filter.component";


export interface IFrameworkSearchSpecsModalInput {
	framework:SelectableFrameworkRef;
}

@Component({
	selector:'app-search-framework-specs-modal',
	templateUrl:'./search-framework-specs-modal.component.html',
	styleUrls:['./search-framework-specs-modal.component.scss'],
	providers:[ValidationErrorService]
})
export class SearchFrameworkSpecsModalComponent implements OnInit, IModal {

	@ViewChild('modal')
	public modal:BsModalRef;
	@ViewChild('frameworkSelect')
	public frameworkSelect:FrameworkSelectComponent;

	private cbContext = Localization.template.modal.search.specify_search_framework_specs;

	public component:FilterComponent;
	public content:IFrameworkSearchSpecsModalInput;
	public errors:BehaviorSubject<object[]> = new BehaviorSubject<object[]>([]);
	public warnings:BehaviorSubject<object[]> = new BehaviorSubject<object[]>([]);

	public CB = {
		title:this.cbContext.title,
		cancel:Localization.template.buttons.cancel,
		setSearchSpecs: this.cbContext.buttons.set_search_specs,
		toast_save_success:this.cbContext.toast.save.success,
		toast_save_fail:this.cbContext.toast.save.fail
	};

	constructor(private bsModalRef:BsModalRef,
				private localizationService:LocalizationService,
				private conversionService:ConversionService,
				private validationErrorService:ValidationErrorService,
				private notificationService:NotificationService) {
	}

	public ngOnInit():void {


	}

	public onProperties(properties:object):void {
		this.content = properties as IFrameworkSearchSpecsModalInput;
	}


	public onCancel() {
		console.info(`user clicked on cancel button`);
		this.bsModalRef.hide();

	}

	public onSetSearchSpecs() {
		console.info(`user clicked on submit button`);
		console.log(`User has selected ${JSON.stringify(this.content.framework.selectedKeys)}`);

		this.frameworkSelect.saveChanges();

		// clear validation errors and warnings
		this.validationErrorService.updateErrors([]);
		this.validationErrorService.updateWarnings([]);

		this.component.onSearchFilterChanged({});

		//try save contribution and return toasts in either case todo: add toasts!
		try {
			//To Do: Validate
			this.notificationService.displayToast(this.CB.toast_save_success, ToastType.success);
			this.bsModalRef.hide();

		} catch (ex) {
			if (ex instanceof ValidationException) {
				console.info(`validation errors caught`);
				this.validationErrorService.updateErrors(ex.errors);
				this.notificationService.displayToast(this.CB.toast_save_fail, ToastType.error)
			} else {
				console.error(ex);
			}
		}
	}

}
